// extracted by mini-css-extract-plugin
export default {"signup_form":"Signup_signup_form__QfMeT"};